export const RELATORIO_DIARIO_CARD = "RELATORIO_DIARIO_CARD";
export const RELATORIO_MENSAL_CARD = "RELATORIO_MENSAL_CARD";
export const RELATORIO_EMPRESAS_EFETIVADAS_CARD =
  "RELATORIO_EMPRESAS_EFETIVADAS_CARD";
export const DASHBOARD = "DASHBOARD";
export const RELATORIO_STATUS = "RELATORIO_STATUS";
